import { gql } from '@apollo/client';

export const CERTIFICATE_QUERY = gql`
    query certificateTemplate( $certificateTemplateId: UUID! ) {
        certificateTemplate( certificateTemplateID: $certificateTemplateId ) {
            node {
                id
                brand {
                    id
                    name
                }
                createdAt
                description
                name
                templateKey
                certificateTemplateUrl
                certificateProfile {
                    id
                    name
                    description
                }
            }
        }    
    }
`;
